function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import GrClose from "@meronex/icons/gr/GrClose";
import { useHistory } from "react-router-dom";
import { isAdani } from "../../../../utils/isClient";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var TicketList = function TicketList(_ref) {
  var winnreAuth = _ref.winnreAuth,
    SkeletonMyOrders = _ref.SkeletonMyOrders,
    Modal = _ref.Modal,
    loadMoreSvg = _ref.loadMoreSvg,
    userRole = _ref.userRole,
    isAuthenticated = _ref.isAuthenticated,
    config = _ref.config;
  var isAdaniClient = isAdani(config);
  var titleFont = isAdaniClient && config !== null && config !== void 0 && config.applyClientFonts ? (config === null || config === void 0 ? void 0 : config.fontTitle) || "" : "";
  var bodyFont = isAdaniClient && config !== null && config !== void 0 && config.applyClientFonts ? (config === null || config === void 0 ? void 0 : config.fontBody) || "" : "";
  var history = useHistory();
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    totalPages = _useState2[0],
    setTotalPages = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    currentPage = _useState4[0],
    setCurrentPage = _useState4[1];
  var loadMoreHandler = function loadMoreHandler() {
    setCurrentPage(function (prev) {
      return prev + 1;
    });
  };
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    requestList = _useState6[0],
    setRequestList = _useState6[1];
  var _useState7 = useState("all"),
    _useState8 = _slicedToArray(_useState7, 2),
    activeFilter = _useState8[0],
    setActiveFilter = _useState8[1];
  var _useState9 = useState(true),
    _useState0 = _slicedToArray(_useState9, 2),
    loading = _useState0[0],
    setLoading = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    selectedRequest = _useState10[0],
    setSelectedRequest = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isModalOpen = _useState12[0],
    setIsModalOpen = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    detailLoading = _useState14[0],
    setDetailLoading = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    actionLoading = _useState16[0],
    setActionLoading = _useState16[1];

  // Fetch all tickets
  var getRequestList = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(activeFilter) {
      var response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            setLoading(true);
            _context.n = 1;
            return winnreAuth({
              method: "GET",
              url: "/winnre/user/smartTicket/all?pageNumber=".concat(currentPage - 1, "&pageSize=4").concat(activeFilter !== "all" ? "&status=".concat(activeFilter) : "", "&source=").concat(userRole === "CUSTOMER" ? "CUSTOMER" : "CHANNEL_PARTNER")
            });
          case 1:
            response = _context.v;
            console.log("response from requestList", response);
            setTotalPages(response.totalPages);
            setRequestList(function (prevState) {
              return currentPage === 1 ? response.content || [] : [].concat(_toConsumableArray(prevState), _toConsumableArray(response.content || []));
            });
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            console.error("Error fetching requests:", _t);
            toast.error("Failed to load tickets");
          case 3:
            _context.p = 3;
            setLoading(false);
            return _context.f(3);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2, 3, 4]]);
    }));
    return function getRequestList(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  // Fetch single ticket details
  var fetchTicketDetails = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(ticketId) {
      var response, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            setDetailLoading(true);
            _context2.n = 1;
            return winnreAuth({
              method: "GET",
              url: "/winnre/user/smartTicket/".concat(ticketId)
            });
          case 1:
            response = _context2.v;
            return _context2.a(2, response);
          case 2:
            _context2.p = 2;
            _t2 = _context2.v;
            console.error("Error fetching ticket details:", _t2);
            throw _t2;
          case 3:
            _context2.p = 3;
            setDetailLoading(false);
            return _context2.f(3);
          case 4:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2, 3, 4]]);
    }));
    return function fetchTicketDetails(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  // Check if ticket can be reopened (within 7 days of resolution)
  var canReopenTicket = function canReopenTicket(resolvedDate) {
    if (!resolvedDate) return false;
    var sevenDaysAgo = moment().subtract(7, "days");
    var resolved = moment(resolvedDate);
    return resolved.isAfter(sevenDaysAgo) && resolved.isSameOrBefore(moment());
  };

  // Open ticket details
  var openRequestDetails = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(request) {
      var details, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.p = 0;
            setDetailLoading(true);
            _context3.n = 1;
            return fetchTicketDetails(request.id);
          case 1:
            details = _context3.v;
            setSelectedRequest(details);
            setIsModalOpen(true);
            _context3.n = 3;
            break;
          case 2:
            _context3.p = 2;
            _t3 = _context3.v;
            toast.error("Failed to load ticket details");
          case 3:
            return _context3.a(2);
        }
      }, _callee3, null, [[0, 2]]);
    }));
    return function openRequestDetails(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  useEffect(function () {
    // Reset to first page and clear existing data when filter changes
    setCurrentPage(1);
  }, [activeFilter]);
  useEffect(function () {
    getRequestList(activeFilter);
  }, [currentPage, activeFilter]); // Add activeFilter to dependencies

  return /*#__PURE__*/_jsxs("div", {
    className: "w-full py-4  px-2 lg:px-4",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "max-w-7xl mx-auto",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex justify-between items-center mb-6",
        children: [/*#__PURE__*/_jsx("h1", {
          className: " text-lg md:text-2xl font-bold",
          children: "My Support Tickets"
        }), /*#__PURE__*/_jsx("button", {
          onClick: function onClick() {
            return history.push("/myprofile/support-tickets");
          },
          className: "px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-dark transition",
          children: "+ New Request"
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "flex flex-wrap gap-2 lg:gap-6 mb-6",
        children: ["all", "OPEN", "INPROGRESS", "RESOLVED", "REOPEN"].map(function (status) {
          return /*#__PURE__*/_jsx("button", {
            onClick: function onClick() {
              return setActiveFilter(status === "all" ? "all" : status);
            },
            className: "px-4 py-2 rounded-md text-xs md:text-sm font-medium ".concat(activeFilter === (status === "all" ? "all" : status) ? "bg-primary text-white" : "bg-gray-50 text-gray-500 hover:bg-gray-100"),
            children: status === "all" ? "ALL" : status
          }, status);
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "",
        children: loading ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "mb-6",
            children: _toConsumableArray(Array(1).keys()).map(function (n) {
              return /*#__PURE__*/_jsx(SkeletonMyOrders, {}, n);
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "mt-4 mb-6",
            children: _toConsumableArray(Array(1).keys()).map(function (n) {
              return /*#__PURE__*/_jsx(SkeletonMyOrders, {}, n);
            })
          })]
        }) : requestList.length === 0 ? /*#__PURE__*/_jsxs("div", {
          className: "text-center py-12",
          children: [/*#__PURE__*/_jsx("h3", {
            className: "text-lg font-medium text-gray-700 mb-2",
            children: "No Support Tickets Found"
          }), /*#__PURE__*/_jsx("p", {
            className: "text-gray-500 mb-4",
            children: "We couldn't find any tickets matching your current filters."
          }), activeFilter !== "all" && /*#__PURE__*/_jsx("button", {
            onClick: function onClick() {
              return setActiveFilter("all");
            },
            className: "px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-dark transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
            children: "Clear All Filters"
          })]
        }) : /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx("div", {
            className: "my-6",
            children: requestList.map(function (request) {
              return /*#__PURE__*/_jsx("div", {
                className: "p-4 hover:bg-gray-50 border border-gray-200 rounded-lg my-2",
                children: /*#__PURE__*/_jsxs("div", {
                  className: "flex flex-row items-center justify-between gap-6",
                  children: [/*#__PURE__*/_jsxs("div", {
                    className: "flex-1",
                    children: [/*#__PURE__*/_jsxs("div", {
                      className: "flex flex-row items-center lg:gap-6 gap-2 my-2",
                      children: [/*#__PURE__*/_jsxs("span", {
                        className: "text-xs md:text-sm font-medium text-gray-500",
                        children: ["Request ID: #", request.ticketId]
                      }), /*#__PURE__*/_jsx("span", {
                        className: "px-3 py-[6px] inline-flex text-xs  leading-5 font-semibold rounded-md ".concat(request.smartTicketStatus === "OPEN" ? "bg-red-100 text-red-700" : request.smartTicketStatus === "INPROGRESS" ? "bg-blue-100 text-blue-800" : request.smartTicketStatus === "RESOLVED" ? "bg-green-100 text-green-800" : "bg-purple-100 text-purple-800"),
                        children: request.smartTicketStatus
                      })]
                    }), request.otherFields ? /*#__PURE__*/_jsxs(_Fragment, {
                      children: [request.requestType === "basic" ? /*#__PURE__*/_jsx("p", {
                        className: "text-sm text-gray-600",
                        children: request.message || "No message"
                      }) : request.requestType === "callback" ? /*#__PURE__*/_jsxs("p", {
                        className: "text-sm text-gray-600",
                        children: ["Callback:", " ", request.otherFields.customerMobile || "-", " at", " ", request.otherFields.preferredDateTime ? moment(request.otherFields.preferredDateTime).format("DD.MM.YYYY, hh:mm A") : "-"]
                      }) : request.requestType === "document" ? /*#__PURE__*/_jsxs("p", {
                        className: "text-sm text-gray-600",
                        children: ["Document:", " ", request.otherFields.documentType || request.otherFields.customDocumentName || "Uploaded Document"]
                      }) : /*#__PURE__*/_jsx("p", {
                        className: "text-sm text-gray-600",
                        children: request.message || "-"
                      }), /*#__PURE__*/_jsxs("p", {
                        className: "text-xs md:text-sm font-medium text-gray-500 mt-1",
                        children: ["Created On:", " ", moment(request.createdOn).format("DD.MM.YYYY")]
                      }), (request === null || request === void 0 ? void 0 : request.smartTicketStatus) === "RESOLVED" && (request === null || request === void 0 ? void 0 : request.resolvedDate) && /*#__PURE__*/_jsxs("p", {
                        className: "text-xs md:text-sm font-medium text-gray-500 mt-1",
                        children: ["Resolved On:", " ", moment(request === null || request === void 0 ? void 0 : request.resolvedDate).format("DD.MM.YYYY")]
                      })]
                    }) : /*#__PURE__*/_jsxs(_Fragment, {
                      children: [/*#__PURE__*/_jsx("p", {
                        className: "text-sm  text-gray-600",
                        children: request.subCategory || "No subcategory"
                      }), /*#__PURE__*/_jsxs("p", {
                        className: "text-xs md:text-sm font-medium text-gray-500 mt-1",
                        children: ["Created On:", " ", moment(request.createdOn).format("DD.MM.YYYY")]
                      }), (request === null || request === void 0 ? void 0 : request.smartTicketStatus) === "RESOLVED" && (request === null || request === void 0 ? void 0 : request.resolvedDate) && /*#__PURE__*/_jsxs("p", {
                        className: "text-xs md:text-sm font-medium text-gray-500 mt-1",
                        children: ["Resolved On:", " ", moment(request === null || request === void 0 ? void 0 : request.resolvedDate).format("DD.MM.YYYY")]
                      })]
                    })]
                  }), /*#__PURE__*/_jsxs("div", {
                    className: "flex flex-col lg:flex-row justify-end md:justify-start gap-4",
                    children: [/*#__PURE__*/_jsx("div", {
                      children: !isAdaniClient && (request === null || request === void 0 ? void 0 : request.smartTicketStatus) === "RESOLVED" && canReopenTicket(request === null || request === void 0 ? void 0 : request.resolvedDate) && /*#__PURE__*/_jsx("button", {
                        onClick: function onClick() {
                          history.push({
                            pathname: "/myprofile/support-tickets",
                            search: "?reopen=true",
                            state: {
                              ticket: request
                            }
                          });
                        },
                        className: "px-3 py-2 text-sm font-medium border border-primary text-primary rounded-md",
                        children: "Reopen Ticket"
                      })
                    }), /*#__PURE__*/_jsx("div", {
                      className: "",
                      children: /*#__PURE__*/_jsx("button", {
                        onClick: function onClick() {
                          return openRequestDetails(request);
                        },
                        className: "px-4 py-2 text-sm font-medium bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 transition-colors",
                        children: "View Details"
                      })
                    })]
                  })]
                })
              }, request.id);
            })
          })
        })
      }), !loading && currentPage < totalPages && (requestList === null || requestList === void 0 ? void 0 : requestList.length) > 0 && /*#__PURE__*/_jsx("div", {
        className: " flex justify-center pb-7 mt-4 ",
        children: /*#__PURE__*/_jsx("button", {
          onClick: loadMoreHandler,
          className: "flex items-center justify-center gap-x-2 mx-auto px-4 py-2 text-gray-500 border-[3px] border-gray-200 rounded mb-6",
          children: /*#__PURE__*/_jsxs(_Fragment, {
            children: ["Load More", loadMoreSvg]
          })
        })
      })]
    }), /*#__PURE__*/_jsxs(Modal, {
      className: "w-[90%] md:w-[50%]",
      visible: isModalOpen && selectedRequest,
      onClick: function onClick() {
        return setIsModalOpen(false);
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex justify-end mr-4 mt-4 mb-2",
        children: /*#__PURE__*/_jsx(GrClose, {
          onClick: function onClick() {
            return setIsModalOpen(false);
          },
          className: " h-4 w-4 cursor-pointer self-end ml-auto"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "bg-white rounded-lg w-full max-w-2xl  flex-items-center overflow-y-scroll h-[90vh] lg:h-auto ".concat(bodyFont),
        children: /*#__PURE__*/_jsxs("div", {
          className: "p-6",
          children: [/*#__PURE__*/_jsx("div", {
            className: "flex justify-between items-start",
            children: /*#__PURE__*/_jsx("h2", {
              className: "text-xl font-bold mb-4 ".concat(titleFont),
              children: "Ticket Details"
            })
          }), detailLoading ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("div", {
              className: "mb-6",
              children: _toConsumableArray(Array(1).keys()).map(function (n) {
                return /*#__PURE__*/_jsx(SkeletonMyOrders, {}, n);
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "mt-4 mb-6",
              children: _toConsumableArray(Array(1).keys()).map(function (n) {
                return /*#__PURE__*/_jsx(SkeletonMyOrders, {}, n);
              })
            })]
          }) : /*#__PURE__*/_jsxs("div", {
            className: "space-y-4",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "grid grid-cols-1 md:grid-cols-2 gap-4",
              children: [/*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx("p", {
                  className: "text-sm font-medium text-gray-500",
                  children: "Ticket ID"
                }), /*#__PURE__*/_jsxs("p", {
                  className: "mt-1",
                  children: ["#", selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.ticketId]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx("p", {
                  className: "text-sm font-medium text-gray-500",
                  children: "Status"
                }), /*#__PURE__*/_jsx("p", {
                  className: "mt-1",
                  children: /*#__PURE__*/_jsx("span", {
                    className: "px-3 py-[6px] text-xs font-medium rounded-md ".concat((selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.smartTicketStatus) === "OPEN" ? "bg-yellow-100 text-yellow-800" : (selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.smartTicketStatus) === "INPROGRESS" ? "bg-blue-100 text-blue-800" : (selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.smartTicketStatus) === "RESOLVED" ? "bg-green-100 text-green-800" : "bg-purple-100 text-purple-800"),
                    children: selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.smartTicketStatus
                  })
                })]
              }), /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx("p", {
                  className: "text-sm font-medium text-gray-500",
                  children: "Request Type"
                }), /*#__PURE__*/_jsx("p", {
                  className: "mt-1",
                  children: (selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.requestType) || "N/A"
                })]
              }), /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx("p", {
                  className: "text-sm font-medium text-gray-500",
                  children: "Subcategory"
                }), /*#__PURE__*/_jsx("p", {
                  className: "mt-1",
                  children: (selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.subCategory) || "N/A"
                })]
              }), /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx("p", {
                  className: "text-sm font-medium text-gray-500",
                  children: "Created On"
                }), /*#__PURE__*/_jsx("p", {
                  className: "mt-1",
                  children: moment(selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.createdOn).format("DD.MM.YYYY, hh:mm A")
                })]
              }), /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx("p", {
                  className: "text-sm font-medium text-gray-500",
                  children: "Last Updated"
                }), /*#__PURE__*/_jsx("p", {
                  className: "mt-1",
                  children: moment(selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.updatedOn).format("DD.MM.YYYY, hh:mm A")
                })]
              }), (selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.smartTicketStatus) === "RESOLVED" && (selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.resolvedDate) && /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx("p", {
                  className: "text-sm font-medium text-gray-500",
                  children: "Resolved On"
                }), /*#__PURE__*/_jsx("p", {
                  className: "mt-1",
                  children: moment(selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.resolvedDate).format("DD.MM.YYYY, hh:mm A")
                })]
              })]
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("p", {
                className: "text-sm font-medium text-gray-500",
                children: "Message"
              }), /*#__PURE__*/_jsx("div", {
                className: "mt-1 p-3 bg-gray-50 rounded whitespace-pre-wrap",
                children: selectedRequest !== null && selectedRequest !== void 0 && selectedRequest.otherFields ? selectedRequest.requestType === "basic" ? (selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.message) || "No message provided" : selectedRequest.requestType === "callback" ? /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsxs("p", {
                    children: ["Mobile:", " ", selectedRequest.otherFields.customerMobile || "-"]
                  }), /*#__PURE__*/_jsxs("p", {
                    children: ["Preferred:", " ", selectedRequest.otherFields.preferredDateTime ? moment(selectedRequest.otherFields.preferredDateTime).format("DD.MM.YYYY, hh:mm A") : "-"]
                  })]
                }) : selectedRequest.requestType === "document" ? /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsxs("p", {
                    children: ["Document Type:", " ", selectedRequest.otherFields.documentType || selectedRequest.otherFields.customDocumentName || "-"]
                  }), selectedRequest.otherFields.documentUrl && /*#__PURE__*/_jsx("p", {
                    className: "mt-2",
                    children: /*#__PURE__*/_jsx("a", {
                      href: selectedRequest.otherFields.documentUrl,
                      target: "_blank",
                      rel: "noreferrer",
                      className: "text-blue-600",
                      children: "View Document"
                    })
                  })]
                }) : (selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.message) || "No message provided" : (selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.message) || "No message provided"
              }), (selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.requestType) === "Document Submission" && (selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.docUrl) && /*#__PURE__*/_jsx("a", {
                href: selectedRequest.docUrl,
                target: "_blank",
                rel: "noreferrer",
                className: "inline-block mt-2 text-blue-600 hover:underline",
                children: "View Uploaded Document"
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "mt-6 pt-4 border-t border-gray-200 flex justify-between flex-wrap gap-3",
            children: [/*#__PURE__*/_jsx("div", {
              className: "flex space-x-3",
              children: /*#__PURE__*/_jsx("button", {
                onClick: function onClick() {
                  return setIsModalOpen(false);
                },
                className: "px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50",
                disabled: actionLoading,
                children: "Close"
              })
            }), /*#__PURE__*/_jsx("div", {
              children: !isAdaniClient && (selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.smartTicketStatus) === "RESOLVED" && canReopenTicket(selectedRequest === null || selectedRequest === void 0 ? void 0 : selectedRequest.resolvedDate) && /*#__PURE__*/_jsx("button", {
                onClick: function onClick() {
                  history.push({
                    pathname: "/myprofile/support-tickets",
                    search: "?reopen=true",
                    state: {
                      ticket: selectedRequest
                    }
                  });
                },
                className: "px-4 py-2 text-sm border border-primary text-primary rounded-md",
                children: "Reopen Ticket"
              })
            })]
          })]
        })
      })]
    })]
  });
};